var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0709 12.3493C13.3329 12.4367 13.616 12.2951 13.7033 12.0331C13.7907 11.7711 13.6491 11.488 13.3871 11.4007L13.0709 12.3493ZM10.4165 10.9375H9.9165C9.9165 11.1527 10.0542 11.3438 10.2584 11.4118L10.4165 10.9375ZM10.9165 7.01739C10.9165 6.74125 10.6926 6.51739 10.4165 6.51739C10.1404 6.51739 9.9165 6.74125 9.9165 7.01739H10.9165ZM13.3871 11.4007L10.5746 10.4632L10.2584 11.4118L13.0709 12.3493L13.3871 11.4007ZM10.9165 10.9375V7.01739H9.9165V10.9375H10.9165ZM17.4165 10C17.4165 13.866 14.2825 17 10.4165 17V18C14.8348 18 18.4165 14.4183 18.4165 10H17.4165ZM10.4165 17C6.55051 17 3.4165 13.866 3.4165 10H2.4165C2.4165 14.4183 5.99823 18 10.4165 18V17ZM3.4165 10C3.4165 6.13401 6.55051 3 10.4165 3V2C5.99823 2 2.4165 5.58172 2.4165 10H3.4165ZM10.4165 3C14.2825 3 17.4165 6.13401 17.4165 10H18.4165C18.4165 5.58172 14.8348 2 10.4165 2V3Z",
    fill: "#657397"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock01);
export default __webpack_public_path__ + "static/media/clock-01.e8640d1c44d9de6064670475f236be3c.svg";
export { ForwardRef as ReactComponent };